
    <!-- Scroll To Top -->
    <div class="scrollToTop"   (click)="taptotop()"
       [ngStyle]="{ display: show ? 'block' : 'none' }"
        style="display: flex"> 
        <span class="arrow"><i class="ri-arrow-up-s-fill fs-20" ></i></span>
    </div>
    <div id="responsive-overlay"></div>
    <!-- Scroll To Top -->

    